import styled from "styled-components";
import logoImg from "../../../../assets/pages/NewHome/MapSection/logo-7cantos.png";

export const Wrapper = styled.div`
  margin-top: 32px;
  padding: 48px 16px;
  border-radius: 16px;
  background: #F1F6FF;
  background: linear-gradient(148deg, rgba(241, 246, 255, 1) 51%, rgba(129, 161, 244, 1) 100%);
  position: relative;
  text-align: center; /* Centraliza tudo no mobile */
  overflow: hidden; /* Previne que elementos saiam do container */

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    text-align: left; /* mobileSm volta alinhamento à esquerda */
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 48px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    padding: 48px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    position: relative;
    overflow: hidden;
    text-align: left;
    gap: 24px;
    padding: 32px 48px;
    min-height: 500px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    min-height: 550px;
    gap: 32px;
    padding: 40px 56px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    min-height: 600px;
    gap: 40px;
    padding: 48px 64px;
  }
`;

export const Logo = styled.div`
  display: none;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: block;
    position: absolute;
    top: 32px;
    left: 48px;
    width: 140px;
    height: 50px;
    background-image: url(${logoImg});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 1;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    top: 40px;
    left: 56px;
    width: 150px;
    height: 55px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    top: 48px;
    left: 64px;
    width: 160px;
    height: 60px;
  }
`;

/* Nova logo para mobile */
export const MobileLogo = styled.div`
  display: block;
  width: 140px;
  height: 50px;
  margin: 0 auto 24px auto;
  background-image: url(${logoImg});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    display: none; /* Some no mobileSm */
  }
`;

export const TitleMapWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    text-align: left;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: block;
    text-align: left;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    display: block;
    text-align: left;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    margin-bottom: 48px;
  }
`;

export const Title = styled.h2`
  font-size: ${16 / 16}rem;
  font-family: "Poppins", sans-serif;
  color: ${({ theme }) => theme.palette.greyscale.grey800};
  font-weight: 600;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${24 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: ${20 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    font-size: ${22 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    font-size: ${24 / 16}rem;
  }
`;

export const Description = styled.p`
  margin-top: 8px;
  font-size: ${14 / 16}rem;
  line-height: ${30 / 16}rem;
  color: ${({ theme }) => theme.palette.greyscale.grey600};
  font-family: "Inter", sans-serif;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${16 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: ${15 / 16}rem;
    line-height: ${24 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    font-size: ${16 / 16}rem;
    line-height: ${26 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    font-size: ${17 / 16}rem;
    line-height: ${28 / 16}rem;
  }
`;

export const StatesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    justify-content: flex-start; /* mobileSm alinha à esquerda */
    gap: 12px;
    margin-top: 16px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    gap: 16px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    gap: 16px;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    margin-top: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    gap: 10px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    gap: 12px;
  }
`;

export const StateContainer = styled.div`
  color: ${({ theme }) => theme.palette.greyscale.grey600};
  font-size: ${14 / 16}rem;
  font-family: "Plus Jakarta Sans", sans-serif;
  margin-top: 0;
  display: flex;
  gap: 4px;
  align-items: center;
  margin-bottom: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    margin-bottom: 8px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 24px;
    margin-bottom: 0;
    
    & svg {
      width: ${20 / 16}rem;
      height: ${20 / 16}rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    font-size: ${15 / 16}rem;
    
    & svg {
      width: ${22 / 16}rem;
      height: ${22 / 16}rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    font-size: ${16 / 16}rem;
    
    & svg {
      width: ${24 / 16}rem;
      height: ${24 / 16}rem;
    }
  }

  & svg {
    width: ${24 / 16}rem;
    height: ${24 / 16}rem;
    color: ${({ theme }) => theme.palette.primary.blue500};
  }
`;

export const MapWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  position: relative; 
  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    position: relative;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-top: 32px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    margin-top: 32px;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    justify-content: center;
    align-items: center;
    margin-top: 0;
    position: static;
  }
`;

export const Image = styled.img`
  height: 280px; 
  width: 100%;
  max-width: 320px; 
  text-align: center;
  object-fit: contain;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    height: 300px;
    max-width: 340px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    height: 320px; 
    max-width: 380px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 400px;
    max-width: none;
    width: auto;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    height: 450px;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    height: 380px;
    max-height: 400px;
    object-fit: contain;
    width: auto;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    height: 420px;
    max-height: 450px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    height: 480px;
    max-height: 500px;
  }
`;

export const MarcosImage = styled.img`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    display: block;
    height: 200px;
    position: absolute;
    right: 0;
    bottom: 0;
    object-fit: contain;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 300px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    height: 350px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    height: 500px;
    position: absolute;
    right: 0;
    bottom: 0;
    max-height: 520px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    height: 550px;
    max-height: 580px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    height: 620px;
    max-height: 650px;
  }
`;

export const MobileMarcosImage = styled.img`
  display: block;
  width: 150px;
  height: auto;
  position: absolute;
  right: 0;
  bottom: 0;
  object-fit: contain;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    display: none;
  }
`;